import { render, staticRenderFns } from "./OrderThumb.vue?vue&type=template&id=316cd4c4&"
import script from "./OrderThumb.vue?vue&type=script&lang=js&"
export * from "./OrderThumb.vue?vue&type=script&lang=js&"
import style0 from "./OrderThumb.vue?vue&type=style&index=0&id=316cd4c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports